import { Component, ElementRef, ViewChild } from "@angular/core";
import { jsPDF } from "jspdf";
import { HomeService } from "../home/home.service";

@Component({
    selector: 'app-comprovante-pagamento',
    templateUrl: './comprovante-pagamento.component.html',
    styleUrls: ['./comprovante-pagamento.component.scss']
})
export class ComprovantePagamentoComponent {
    @ViewChild('pdfTable', { static: false }) pdfTable!: ElementRef;

    body?: any;

    constructor(
        private homeService: HomeService
    ) {
        this.body = this.homeService.body;
    }

    gerarPDF() {

        const doc = new jsPDF('p', 'mm', 'a4');

        const texts = `
    <div class="html-pdf">
        <div class="body-pdf">
            <div class="row-pdf coupon-wrapper-pdf" id="couponPage-pdf" #couponPage-pdf style="width:794px; height: 800px;">
                <div class="coupon-container-pdf">
                    <div class="page-pdf">
                        <div class="subpage-one-pdf">
                            <div class="logo_adjust-pdf"> </div> <!-- início da primeira página -->
                            <div class="page-one-pdf">
                                <div class="subpage-title-pdf">
                                    <div class="title-pdf">Comprovante de Pagamento</div> <br /><br />
                                </div>
                                <div class="container-pdf">
                                    <div class="half-pdf">
                                        <div class="card-title-pdf"> <span>Realizado em</span> </div> <span class="text_adjust-pdf card-content-pdf text-content-pdf">${this.body.dataPagamento}</span>
                                    </div>
                                    <div class="half-pdf" style="margin-left: 5px; margin-right: 5px">
                                        <div class="card-title-pdf"> <span> Valor da Garantia</span> </div> <span class="card-content-pdf text-content-pdf">${this.body.valorGarantia}</span>
                                    </div>
                                    <div class="half-pdf">
                                        <div class="card-title-pdf"> <span> Número da Garantia </span> </div> <span class="card-content-pdf text-content-pdf">${this.body.numeroGarantia}</span>
                                    </div>
                                </div>
                                <div class="container-pdf">
                                    <div class="half-pdf full-width-pdf">
                                        <div class="card-title-pdf">Dados do Titular</div>
                                        <div class="box-pdf">
                                            <div class="card-1-pdf"> <span class="card-content-pdf subtitle-text-pdf">Nome Completo / Razão Social</span> <br /> <span class="card-content-pdf">${this.body.dadosTitular}</span> </div>
                                            <div class="card-2-pdf"> <span class="card-content-pdf subtitle-text-pdf">CPF / CNPJ</span> <br /> <span class="card-content-pdf">${this.body.cpfCnpj}</span> </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="container-pdf">
                                    <div class="half-pdf full-width-pdf">
                                        <div class="card-title-pdf">Dados do Pagamento</div>
                                        <div class="box-pdf">
                                            <div class="card-1-pdf"> <span class="card-content-pdf subtitle-text-pdf">Forma de Cobrança</span> <br /> <span class="card-content-pdf">${this.body.formaCobranca}</span> </div>
                                            <div class="card-1-pdf"> <span class="card-content-pdf subtitle-text-pdf">Valor do Pagamento</span> <br /> <span class="card-content-pdf">${this.body.valorPagamento}</span> </div>
                                            <div class="card-3-pdf"> <span class="card-content-pdf subtitle-text-pdf">Bandeira do Cartão</span> <br /> <span class="card-content-pdf">${this.body.bandeiraCartao}</span> </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="footer-container-pdf">
                                    <div class="full-width-pdf">
                                        <div class="footer-title-pdf">

                                        </div>
                                        <div class="box1-pdf">
                                            <div>
                                                <center><span class="card-content-pdf footer-subtitle-pdf">© copyright 2023 — BRASILCAP. Todos os direitos reservados</span> </center>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;

        doc.setFontSize(1)


        doc.html(texts, {
            callback: (doc) => {
                // Carrega a imagem
                const img = new Image();
                img.src = '../../../../assets/images/logo_bb_b.svg';
                img.crossOrigin = 'anonymous';

                // Quando a imagem é carregada, adiciona ao PDF
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    //canvas.style.position = 'absolute';
                    //canvas.style.top = '40px';
                    //canvas.style.right = '300px';
                    const ctx = canvas.getContext('2d');
                    if (ctx) {
                        ctx.drawImage(img, 0, 0);
                        const dataUrl = canvas.toDataURL('image/png');
                        doc.addImage(dataUrl, 'PNG', 140, 24, 50, 0); // Adicione a imagem na posição desejada
                        doc.save(`comprovante_pagamento_${this.body.numeroGarantia}.pdf`); // Salva o PDF
                    }
                };
            },
            margin: [0, 0, 0, 0],
            x: 0,
            y: 0,
            html2canvas: {
                scale: 0.27,
                width: 100
            },
        });

    }

}
